import aboutPage from './aboutPage'

const config = {
  aboutPage,
  contactModalPalette: {
    background: '#e8ebed', surface: '#ffffff', text: '#354a54', muted: '#596a73',
    buttonBackground: '#354a54', buttonHover: '#253740', buttonText: '#ffffff',
  },
  trustedExternalDomains: ['moebelzeppenfeld.de'],

  customerProject: {
    key: 'designmoebelkaufen',
    shopIds: [204],
    template: 'designmoebelkaufen',
  },

  // Template-Elemente
  productLagerwareTopAlert: false,
  stockDeliveryTime: 14,
  couponDisplay:true,
  VorkasseDisplay:true,
  NachnahmeDisplay:true,
  RechnungDisplay:true,
  PayPalAdvancedCardsDisplay:true,
  PayPalGooglePayDisplay:true,
  PayPalApplePayDisplay:true,
  PayPalPayLaterDisplay:true,
  versandkosten: {
    spedition: 89,
    speditionAusland: {},
  },
  productInquiry: {
    buttonLabel: 'Kontaktieren Sie uns',
    cartInquiryButtonLabel: 'Kontaktieren Sie uns',
    inquiryOnlyButtonLabel: 'Kontaktieren Sie uns',
    buttonBackgroundColor: '#fba466',
    buttonHoverColor: '#f39355',
    buttonTextColor: '#2f2d27',
    availabilityLabel: 'Nur auf Anfrage',
    detailNotice: 'Dieser Artikel ist nur auf Anfrage erhältlich. Der Preis bleibt sichtbar, die Bestellung erfolgt aber nicht direkt online.',
    onlyInquiryNotice: 'Dieser Artikel ist nur auf Anfrage erhältlich. Der Preis bleibt sichtbar, die Bestellung erfolgt für diesen Artikel aber nicht direkt online.',
    selectionHint: 'Bitte wählen Sie erst alle Varianten aus, bevor Sie die Anfrage senden.',
  },

  productPreview: {
    mobileStyle: 'editorial',
  },

  productImageViewer: {
    variant: 'fullscreen',
  },

  // Strukturierte Daten: Standardwerte je Shop vor Launch pruefen.
  structuredData: {
    returns: {
      merchantReturnDays: 14,
      returnFees: 'https://schema.org/ReturnFeesCustomerResponsibility',
      returnMethod: 'https://schema.org/ReturnByMail',
      refundType: 'https://schema.org/FullRefund',
    },
    shipping: {
      destinationCountry: 'DE',
      handlingTime: { minValue: 0, maxValue: 1, unitCode: 'DAY' },
      shippingTypes: {
        1: { name: 'Warenpost', rate: 'deutschland' },
        10: { name: 'Paket-Versand', rate: 'deutschland' },
        12: { name: 'Paket-Versand Sperrgut', rate: 'deutschland' },
        20: { name: 'Speditions-Versand', rate: 'spedition' },
        30: { name: 'Speditions-Versand Sperrgut', rate: 'spedition' },
      },
      defaultShippingType: 10,
    },
  },
  
  // PayPal
  paypal: {
    live: {
      "client-id": 'AR0cAg3hx9OP8zlFOpwFoL3Ozn6NVY1KQprIeXOldNaSr6-YtEOa6lNCv-9r7SwzHdf4fXqcc5dTC6uD',
      //"data-client-token": "abc123xyz==",
    },
    dev: {
      "client-id": 'AanrUkdKeHQ2hoqUX_WLOw7rXPPJGmblaNMbRz-xi3FEOI3sGO0CBJHvH7w4aDvYtwYXq6t7jQiAvHyf',
      //"data-client-token": "abc123xyz==",
    },
  },

  // Footer
  brands: [

    //36,  // Joop!
    //62,  // Essenza
    //61,  // Pip Studio
    //166, // Greengate

    //42,  // Bassetti
    34,  // Formesse
    160, // The Laundress
    189, // Bondi Wash

    203, // Meraki
    201, // Claus Porto
    190, // Björk & Berries
    196, // Le Jacquard Francais
    
  ]

} as const

export default config
